
import { useState, useEffect } from 'react';

interface HeroProps {
  onOpenContactForm: () => void;
}

export default function Hero({ onOpenContactForm }: HeroProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Navigation */}
      <nav className={`md:fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img src="https://static.readdy.ai/image/5f53cefd87e94fc6c03249023a0b95b5/0c8167376927e032ee82e947bbcb1c66.png" alt="INFORESTA インフォレスタ" className="h-14" />
            </div>
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#eb4b3f]' : 'text-white hover:text-[#f0945b]'}`}>サービス案内</a>
              <a href="#flow" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#eb4b3f]' : 'text-white hover:text-[#f0945b]'}`}>ご利用の流れ</a>
              <a href="#pricing" className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#eb4b3f]' : 'text-white hover:text-[#f0945b]'}`}>料金について</a>
            </div>
            <button className="md:hidden text-white">
              <i className={`ri-menu-line text-2xl ${scrolled ? 'text-gray-700' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20research%20library%20with%20organized%20white%20shelving%20and%20bright%20natural%20lighting%2C%20professional%20healthcare%20documentation%20center%20with%20minimalist%20design%2C%20soft%20ambient%20lighting%20creating%20peaceful%20scholarly%20atmosphere%2C%20subtle%20green%20accents%20throughout%20the%20space%2C%20organized%20academic%20environment&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
            alt="医学文献検索サービス"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/20"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
          <div className="bg-white/85 backdrop-blur-sm rounded-3xl px-8 py-12 md:px-12 md:py-16 shadow-2xl">
            <h1 className="text-5xl md:text-6xl font-bold text-[#eb4b3f] mb-6" style={{ textShadow: '2px 2px 4px rgba(255,255,255,0.9), -1px -1px 2px rgba(255,255,255,0.7), 0 0 8px rgba(255,255,255,0.5)' }}>
              <span className="md:inline block">キーワード</span>
              <span className="md:inline block">検索サービス</span>
            </h1>
            <p className="text-lg md:text-xl text-[#2c5f2d] mb-12 max-w-3xl mx-auto leading-relaxed font-semibold" style={{ textShadow: '2px 2px 3px rgba(255,255,255,0.95), -1px -1px 2px rgba(255,255,255,0.8), 0 0 6px rgba(255,255,255,0.6)' }}>
              お客様に代わって検索のプロがご希望に合う文献を選定し、リストでご案内します。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <button
                onClick={onOpenContactForm}
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#eb4b3f] to-[#f0945b] text-white text-base font-semibold rounded-full hover:from-[#d43d31] hover:to-[#e08549] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-circle-line mr-2 text-xl"></i>
                キーワード検索を利用する
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
